/**
 * M4 — today. ROW ONLY (O1 resolved as "a click away"): the next matched
 * calendar event as one compact line that opens the event. Variants: single,
 * several ("N people today · next: …"), brief pending, post-event ("how was
 * it?"). Class 1, never dismissable.
 *
 * The tap is `open`: the app opens the life tab; web has no calendar
 * surface, so the host's route map puts the natural reply in the composer.
 */

import { Calendar } from 'react-feather';
import { HomeGlyph, HomeRow } from '../HomeKit';
import { formatClock, joinNames } from '../format';
import type { ModuleProps } from '../moduleTypes';

export function TodayModule({ module, onAction }: ModuleProps) {
  if (module.type !== 'today') return null;
  const { payload } = module;
  const names = joinNames(payload.personNames);

  let body: string;
  let sub: string | undefined;
  let status: 'ready' | 'pending' | null = null;

  if (payload.several) {
    const { count, next, then } = payload.several;
    body = `${count} people today`;
    sub = `next: ${next.personName} at ${formatClock(next.startsAt)}`;
    if (then) sub += ` · then ${then.personName} at ${formatClock(then.startsAt)}`;
  } else if (payload.postEvent) {
    body = `How was it with ${names}?`;
    sub = 'tell f8 how it went';
  } else {
    body = payload.allDay ? `${names} · all day` : `${names} at ${formatClock(payload.startsAt)}`;
    status = payload.briefStatus;
    if (status === 'pending') sub = 'brief on its way — tap to open anyway';
  }

  return (
    <HomeRow
      reason={module.reason}
      body={body}
      sub={sub}
      glyph={
        <HomeGlyph tone="magenta">
          <Calendar size={14} />
        </HomeGlyph>
      }
      trailing={
        status ? (
          <span className={`home-status${status === 'ready' ? ' home-status--ready' : ''}`}>
            {status === 'ready' ? 'brief ready' : 'preparing…'}
          </span>
        ) : null
      }
      dismissable={false}
      onOpen={() => onAction?.({ kind: 'open' }, module)}
    />
  );
}
